<template>
  <div class="activities-index">
    <div class="row">
      <div class="col-12 d-none d-sm-block" style="margin-top: 5px">
        <a v-for="child in children" :key="child.id" :href="'#child-' + child.id" class="text-center" style="display: inline-block; margin-right: 10px; text-decoration: none;">
          <child-thumbnail :child="child" :height="'75px'"></child-thumbnail>
          <p style="font-size: 12px">
            {{ child.first_name }}
          </p>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="">
        <div v-if="childRows.length > 0">
          <template v-for="row in childRows" :key="row.child.id">
            <div v-if="row.isFirstUnplanned" class="unplanned-separator">
              <span>Geen planning op geselecteerde groep(en)</span>
            </div>
          <div style="background: white; height: 100%; padding: 15px; padding-bottom: 8px; margin-bottom: 20px;">
            <a :id="'child-' + row.child.id"></a>
            <div class="row">
              <div class="col-sm-2 col-12 text-center">
                <div class="row">
                  <div class="col-sm-12 col-6">
                    <child-thumbnail :child="row.child"></child-thumbnail>
                  </div>
                  <div class="col-sm-12 col-6">
                    <router-link :to="'/children/' + row.child.id + '/activities'">
                      <h4 style="margin: 0; margin-top: 5px">
                        {{ row.child.first_name }}
                      </h4>
                      <p style="margin: 5px; margin-top: 0">
                        {{ row.child.last_name_suffix }} {{ row.child.last_name }}
                      </p>
                    </router-link>
                    <router-link :to="'/children/' + row.child.id">
                      <span v-on:click="selectChild(row.child)">
                        <icon class="pe-1" name="info"></icon>
                      </span>
                    </router-link>
                    <span v-if="canAddActivities" v-on:click="openModalWithChild(row.child)">
                      <icon name="add"></icon>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-10 col-12">
                <span v-if="row.activities.length > 0">
                  <div
                      v-for="(activity, index) in row.activities"
                      :key="activity.id"
                  >
                    <activity-list-item
                        :activity="activity"
                        :divider="index !== (row.activities.length - 1)"
                        :showEdit="canEditActivities"
                        @onEdit="editActivity($event)"
                        :showDelete="canDeleteActivities"
                        @onDelete="deleteActivity($event)"
                    />
                  </div>
                </span>
                <p v-else>Geen activiteiten vandaag</p>
              </div>
            </div>
          </div>
          </template>
        </div>
        <div v-else>
          <p class="text-center">Geen kinderen</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityListItem from '@/components/Activity-List-Item'
import ChildThumbnail from '@/components/Child-Thumbnail'
import Icon from '@/components/Icon'
export default {
  name: 'activities-index',
  components: {
    ActivityListItem,
    ChildThumbnail,
    Icon
  },
  props: {
    showPresentChildrenOnly: {
      default: true,
      type: Boolean
    },
    date: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      childIdsWithPlanningOnSelectedDate: []
    }
  },
  computed: {
    selectedGroupsQueryString () {
      return this.$store.getters.selectedGroupsQueryString
    },
    selectedGroupIds () {
      return String(this.selectedGroupsQueryString || '').split(',').filter((id) => id !== '').map(Number)
    },
    children () {
      var children = []
      children = this.getChildren()
      var app = this
      children = this.$lodash().filter(children, function (child) {
        if (app.showPresentChildrenOnly === true && !app.getChildIsPresent(child)) {
          return false
        }
        return app.getChildHasPlanningOnSelectedDate(child.id) || app.getChildHasActivities(child.id)
      })
      return children.sort(function (childA, childB) {
        return Number(app.getChildHasPlanningOnSelectedDate(childB.id)) - Number(app.getChildHasPlanningOnSelectedDate(childA.id))
      })
    },
    childRows () {
      const rows = []
      let previousWasPlanned = false
      for (let i = 0; i < this.children.length; i++) {
        const child = this.children[i]
        const isPlanned = this.planningChildIds.has(String(child.id))
        rows.push({
          child,
          activities: this.getActivitiesForChild(child.id),
          isFirstUnplanned: !isPlanned && (i === 0 || previousWasPlanned)
        })
        previousWasPlanned = isPlanned
      }
      return rows
    },
    canAddActivities () {
      return this.isAuthorized('communication', 'activities', 'add')
    },
    canEditActivities () {
      return this.isAuthorized('communication', 'activities', 'edit')
    },
    canDeleteActivities () {
      return this.isAuthorized('communication', 'activities', 'delete')
    },
    planningChildIds () {
      var ids = new Set()
      for (var i = 0; i < this.childIdsWithPlanningOnSelectedDate.length; i++) {
        ids.add(String(this.childIdsWithPlanningOnSelectedDate[i].child_id))
      }
      return ids
    },
    activitiesByChildId () {
      var rawActivities = this.$store.getters.groupActivities
      var activitiesPerChild = {}
      if (rawActivities) {
        for (var i = 0; i < rawActivities.length; i++) {
          var activityItem = rawActivities[i]
          var childId = String(activityItem.child_id)
          if (!Object.prototype.hasOwnProperty.call(activitiesPerChild, childId)) {
            activitiesPerChild[childId] = []
          }
          activitiesPerChild[childId].push(activityItem)
        }
      }
      return activitiesPerChild
    }
  },
  watch: {
    date (newDate) {
      this.loadChildIdsWithPlanningOnSelectedDate()
      this.$store.dispatch('getGroupActivities', newDate)
    },
    selectedGroupsQueryString () {
      this.loadChildIdsWithPlanningOnSelectedDate()
      this.$store.dispatch('getChildren')
      this.$store.dispatch('getChildrenPresence')
      this.$store.dispatch('getGroupActivityTypes')
      this.$store.dispatch('getGroupActivities', this.date)
    }
  },
  created () {
    this.loadChildIdsWithPlanningOnSelectedDate()
    this.$store.dispatch('getChildren')
    this.$store.dispatch('getChildrenPresence')
    this.$store.dispatch('getGroupActivityTypes')
    this.$store.dispatch('getGroupActivities', this.date)
  },
  methods: {
    getChildHasPlanningOnSelectedDate (idChild) {
      return this.planningChildIds.has(String(idChild))
    },
    getChildHasActivities (idChild) {
      return this.getActivitiesForChild(idChild).length > 0
    },
    getActivitiesForChild (idChild) {
      const activities = this.activitiesByChildId[String(idChild)] || []
      if (this.getChildHasPlanningOnSelectedDate(idChild)) {
        return activities
      }
      return activities.filter((activity) => {
        if (!Array.isArray(activity.id_groups)) {
          return true
        }
        return activity.id_groups.some((idGroup) => this.selectedGroupIds.includes(Number(idGroup)))
      })
    },
    loadChildIdsWithPlanningOnSelectedDate () {
      this.$request.get('/events/has-planning-on-date?id_group=' + this.selectedGroupsQueryString + '&date=' + this.date)
      .then((response) => {
        if (response.data) {
          this.childIdsWithPlanningOnSelectedDate = response.data
        } else {
          this.childIdsWithPlanningOnSelectedDate = []
        }
      })
    },
    sortActivities (activities) {
      return activities
    },
    selectChild (child) {
      if (child.id_child) {
        child.id = child.id_child
      }
      if (child.id) {
        child.id_child = child.id
      }
      this.$store.commit('SET_SELECTED_CHILD', child)
    },
    openModalWithChild (child) {
      this.$emit('openModalWithChild', child)
    },
    deleteActivity (activity) {
      if (confirm('Weet je zeker dat je deze activiteit wilt verwijderen?') !== true) {
        return
      }
      this.$request.delete('/activities/' + activity.id)
      .then((
      ) => {
        this.$store.dispatch('getGroupActivities', this.date)
        this.appendChildrenById([activity.child_id])
      })
    },
    editActivity (activity) {
      this.$emit('openModalWithActivity', activity)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a {
    color: #666;
  }
  .activities-index :deep(.thumbnail) {
    background-attachment: scroll;
  }
  .unplanned-separator {
    border-top: 1px solid #adb5bd;
    color: #6c757d;
    margin: 30px 0 20px;
    text-align: center;
  }
  .unplanned-separator span {
    background: #efeff4;
    padding: 0 12px;
    position: relative;
    top: -12px;
  }
</style>
